'use strict';
(function() {
    const _t = init('com.crocro.util');

    // Xorshift | シード付き擬似乱数
    // new Xors(n);でオブジェクトを作成して使います。
    _t.Xorshift = function(n) {
        let x, y, z, w;

        // シード
        this.seed = function(n) {
            x = 123456789; y = 362436069; z = 521288629; w = 88675123;
            if (typeof n === "number") {w = n;}
        }
        // ランダム
        this.rnd = function() {
            const t = x ^ (x << 11);
            x = y; y = z; z = w;
            return w = (w^(w>>19))^(t^(t>>8));
        }

        // 初回実行
        this.seed(n);
    };

    // 初期化用関数
    function init(p) {
        try {return module.exports = {}} catch(e) {}
        return ((o, p) => {
            p.split('.').forEach(k => o = o[k]||(o[k]={}));
            return o})(window, p);
    };
})();


// WEBPACK FOOTER //
// ./src/components/gamescript/xorshift.js